"use client";
import useMobileDetect from "@/hooks/useMobileDetect";
import { Button, Image } from 'antd';
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";
import Link from "next/link";

type GraphicsType = {
  isFirstMobile: boolean;
  data: any;
};

export const GraphicsText: React.FC<GraphicsType> = ({ isFirstMobile, data }) => {

  const isMobile = useMobileDetect(isFirstMobile);
  const { name, pic_description, h5_pic, pc_pic, alt_text, little_word, button_name, layout_type, link } = data.card_content;
  const isLeft = layout_type === 1;


  const _renderPcCardContent = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: isLeft ? 'row' : 'row-reverse',
          gap: isLeft ? 32 : 80,
          margin: '0 32px',
        }}
      >
        <div style={{ width: '50%' }}>
          <div className="relative w-full" style={{ paddingTop: '89.4736842%' }}>
            {pc_pic && (
              <ImageWithSkeleton
                src={process.env.NEXT_PUBLIC_IMAGE_URL + pc_pic}
                alt={alt_text}
                width={76}
                height={68}
              />
            )}
          </div>
        </div>
        <div style={{ width: '50%', textAlign: 'left' }}>
          <div
            style={{
              fontSize: 16,
              lineHeight: '24px',
              color: '#402C22',
              marginTop: 32,
            }}
          >
            {little_word}
          </div>
          <div
            style={{
              fontSize: 36,
              lineHeight: '44px',
              color: '#402C22',
              marginTop: 32,
              fontWeight: 500,
            }}
          >
            {name}
          </div>
          <div
            style={{
              fontSize: 18,
              lineHeight: '26px',
              color: '#402C22',
              marginTop: 40,
            }}
          >
            {pic_description}
          </div>
          {button_name && (
            link 
            ?
            <Link target="_blank" href={link}>
              <Button style={{ 
                marginTop: 100, 
                backgroundColor: isLeft ? '#F3F2EC' : '#402C22',
                color: isLeft ? '#402C22' : '#fff'
              }}>
                {button_name}
              </Button>
            </Link>
            :
            <Button
              style={{
                marginTop: 100,
                backgroundColor: isLeft ? '#F3F2EC' : '#402C22',
                color: isLeft ? '#402C22' : '#fff',
              }}
            >
              {button_name}
            </Button>
          )}
        </div>
      </div>
    );
  };
  const _renderMobileCardContent = () => {
    return (
      <>
        <div className="relative w-full" style={{paddingTop: '100%'}}>
          {h5_pic && (
            <ImageWithSkeleton
              src={process.env.NEXT_PUBLIC_IMAGE_URL + h5_pic}
              alt={alt_text}
              width={100}
              height={100}
            />
          )}
        </div>

        <div style={{ width: '100%', textAlign: 'left', margin: '0 16px' }}>
          <div
            style={{
              fontSize: 14,
              lineHeight: '22px',
              color: '#402C22',
              marginTop: 32,
            }}
          >
            {little_word}
          </div>
          <div
            style={{
              fontSize: 32,
              lineHeight: '40px',
              color: '#402C22',
              marginTop: 24,
              fontWeight: 500,
            }}
          >
            {name}
          </div>
          <div
            style={{
              fontSize: 16,
              lineHeight: '24px',
              color: '#402C22',
              marginTop: 24,
            }}
          >
            {pic_description}
          </div>
          {button_name && (
            link 
            ?
            <Link target="_blank" href={link}>
              <Button style={{ marginTop: 56, backgroundColor: '#402C22', color: '#fff' }}>
                {button_name}
              </Button>
            </Link>
            :
            <Button style={{ marginTop: 56, backgroundColor: '#402C22', color: '#fff' }}>
              {button_name}
            </Button>
          )}
        </div>
      </>
    );
  };

  return (
    <div
      style={{
        marginBottom: isMobile ? 24 : 36,
      }}
    >
      {isMobile ? <>{_renderMobileCardContent()}</> : <>{_renderPcCardContent()}</>}
    </div>
  );
}